import styled from 'styled-components/macro'
import { Thread } from 'styles/misc'
import { mq } from 'styles/mq'

export const Img = styled.img`
  max-width: 150%;
  transform: translateX(5%);

  ${mq.medium} {
    max-width: 42.6rem;
    transform: none;
  }
`

export const Figure = styled.figure`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;

  ${mq.smallOnly} {
    flex-direction: column-reverse;
    gap: 2.5rem;
  }

  &::before {
    ${Thread}
    top: 120%;
    width: 100vw;
    aspect-ratio: 1440 / 899;
    transform: translateY(-65%);
    mask-image: url("data:image/svg+xml,%3Csvg width='1440' height='899' viewBox='0 0 1440 899' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1730.37 4.02996C1683.38 0.969958 1635.8 -1.88004 1589.5 6.70996C1543.2 15.3 1497.57 36.62 1468.8 73.9C1429.82 124.4 1424.1 199.7 1372.11 236.68C1343.98 256.69 1307.89 260.85 1273.49 263.78C1161.83 273.28 1071.11 247.7 1000.97 348.79C942.8 432.64 873.73 516.48 777.49 550.43C703.25 576.62 621.53 569.74 544.15 555.3C466.77 540.86 390.18 519.14 311.5 516.51C232.83 513.87 149.18 533.17 93.8798 589.19C41.2398 642.52 22.3598 719.53 -12.7602 785.74C-47.8802 851.94 -117.27 914.08 -189.74 895.01' stroke='white' vector-effect='non-scaling-stroke' stroke-width='1.5' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
  }
`

export const FigCaption = styled.figcaption`
  position: relative;
  font-size: 1rem;

  span {
    --size: 2rem;

    display: block;
    width: var(--size);
    height: var(--size);
    margin: 0 auto 2.5rem;
    border-radius: 50%;
    background-color: rgba(149, 176, 214, 0.8);
  }

  ${mq.smallOnly} {
    text-align: center;
    display: flex;
    flex-direction: column-reverse;
  }

  ${mq.medium} {
    max-width: 12em;
    font-size: 1.4rem;

    span {
      --size: 2.6rem;

      position: absolute;
      left: 100%;
      top: 50%;
      margin: calc(-0.5 * var(--size)) calc(1.2 * var(--size));
    }
  }
`
